import type { PbsDrillDownSortField, PbsDrillDownSortOrder } from '../types';

function compareText(a: string, b: string, dir: number): number {
  const comparison = a.localeCompare(b, undefined, { sensitivity: 'base' });
  return comparison !== 0 ? dir * comparison : 0;
}

/**
 * Stable sort of employee ids for the drill-down modal. Only the Value column
 * ('metricValue') is user-sortable; 'employeeId' is the default order.
 */
export function sortPbsDrillDownEmployeeIds(
  employeeIds: string[],
  metricValueByEmployeeId: Record<string, number>,
  field: PbsDrillDownSortField,
  order: PbsDrillDownSortOrder
): string[] {
  const dir = order === 'asc' ? 1 : -1;
  const ids = [...employeeIds];

  ids.sort((a, b) => {
    let primary = 0;
    if (field === 'metricValue') {
      const valueA = metricValueByEmployeeId[a] ?? Number.NEGATIVE_INFINITY;
      const valueB = metricValueByEmployeeId[b] ?? Number.NEGATIVE_INFINITY;
      if (valueA !== valueB) primary = dir * (valueA - valueB);
    } else {
      primary = compareText(a, b, dir);
    }
    if (primary !== 0) {
      return primary;
    }
    return compareText(a, b, 1);
  });

  return ids;
}
